import React, { Component } from 'react'

import FontIcon from '../../atoms/FontIcon'

import style from './style.css'

export default class ImageDropArea extends Component {

    componentDidMount() {
        let dropzone = this.refs.droparea

        dropzone.ondrop = function(e) {
            e.preventDefault()
            e.stopPropagation()
            dropzone.className = `${style.droparea}`

            this.change({
                target: {
                    files: e.dataTransfer.files
                }
            })
        }.bind(this)


        dropzone.ondragover = function(e) {
            e.stopPropagation()
            dropzone.className = `${style.droparea} ${style.dragover}`
            return false
        }

        dropzone.ondragleave = function(e) {
            dropzone.className = `${style.droparea}`
            return false;
        }
    }

    change(e) {
        let el = e.target
        var files = el.files
        for (var i = 0; i < files.length; i++) {
            var file = files[i]
            if(file.type.split('/')[0] !== 'image') {
                delete el.files[i]
            }

        }
        this.props.files(el.files)
        el.value = ''
    }

    render() {
        return (
            <div className={`${style.droparea}`} ref='droparea' onClick={() => { this.refs.files.click() }}>
                <div>
                    <input className={style.fileUpload} type='file' ref='files' onChange={(e) => this.change(e)} multiple accept="image/*"/>

                    <div className={style.icon}>
                        <FontIcon name='camera' color='#f50'/>
                    </div>
                    <span className={style.msgDefault}>
                        {this.props.componentes.drag && (
                            this.props.componentes.drag()
                        )}
                    </span>
                    <span className={style.msgDrop}>
                        {this.props.componentes.drop && (
                            this.props.componentes.drop()
                        )}
                    </span>

                    <div className={style.btns}>
                        <div className={style.btn}>
                            {this.props.componentes.find && ( this.props.componentes.find() )}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/ImageDropArea-mobile/index.js